export enum MemberAccessLevel {
    None,
    Partial,
    TrialMember,
    Member,
    Declined,
    RecycleFailed,
    FreemiumExMember,
    Paused,
}